import React from 'react';
export const Header = ({ children }) => {
    return React.createElement("header", { className: "header" }, children);
};
export const SubHeader = ({ onClick, children }) => {
    return (React.createElement("div", { className: "subheader", onClick: onClick },
        React.createElement("div", { className: "content" }, children)));
};
//# sourceMappingURL=Header.js.map